export enum ETutorialEvent {
  End      = 'Game:Tutorial:End',     // Egyetlen tutorial item véget ért, klikkre váltunk
  Roll     = 'Game:Tutorial:Roll',    // Jöhet a következő
  Finished = 'Game:Tutorial:Finished' // Az összes tutorial véget ért
}
